'use client';

import { cn } from '@zealot/ui/lib/utils';
import { HexColorPicker, RgbaStringColorPicker } from 'react-colorful';

import { useColorPicker } from './color-picker';

type ColorPickerAreaProps = {
  className?: string;
};

const ColorPickerArea = ({ className }: ColorPickerAreaProps) => {
  const { color, format, onChange, fieldProps } = useColorPicker();
  const isDisabled = Boolean(fieldProps.disabled);
  const handleChange = (nextColor: string) => {
    if (!isDisabled) onChange(nextColor);
  };

  const pickerProps = {
    'data-slot': 'color-picker-area',
    inert: isDisabled,
    className: cn('rounded-lg', className),
    color,
    onChange: handleChange,
  };

  return format === 'rgba' ? <RgbaStringColorPicker {...pickerProps} /> : <HexColorPicker {...pickerProps} />;
};

export type { ColorPickerAreaProps };
export { ColorPickerArea };
